import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getList, getRecord } from '../../../../services/deepstream';
import { useCurrentBoard } from '../../../../services/state';

import ColorPicker from '../../../common/color-picker/ColorPicker';

import './AddCircle.css';
import '../../../../App.css';
import '../../../../style/Common.css';

const AddCircle = () => {
  const { id: boardId } = useCurrentBoard();

  const [title, setTitle] = useState('');
  const [color, setColor] = useState('#7858FB');
  const [role, setRole] = useState('group');

  const createCircle = async (circleId, properties, addCircleToTheBoardNow) => {
    const circle = getRecord(circleId);
    await circle.whenReady();

    if (properties) {
      circle.set({ ...properties });
    }

    if (addCircleToTheBoardNow) {
      addCircleToTheBoard(circleId);
    }
  };

  const deleteCircle = async circleId => {
    const circle = getRecord(circleId);
    await circle.whenReady();

    if (circle) {
      circle.delete();
    }
    return;
  };

  const addCircleToTheBoard = async (circleId, parentId) => {
    if (parentId) {
      await updateCircleData(circleId, { parentId });
    }

    const nodeList = getList(`definition/${boardId}`);
    await nodeList.whenReady();

    nodeList.addEntry(circleId);
  };

  const updateCircleData = async (circleId, data) => {
    const circle = getRecord(circleId);
    await circle.whenReady();

    Object.keys(data).forEach(field => {
      circle.set(field, data[field]);
    });
  };

  const handleSubmit = e => {
    const circleId = uuidv4();
    const circleRecordId = `${boardId}/circle/${circleId}`;

    e.preventDefault();
    const timestamp = new Date().getTime();
    createCircle(
      circleRecordId,
      {
        title,
        id: circleId,
        parentId: 'root',
        role,
        color,
        timestamp,
        circleBg: ''
      },
      true
    );
  };

  const handleDragStart = event => {
    const oldDragImage = document.getElementById('drag-image');
    if (oldDragImage) {
      oldDragImage.remove();
    }

    const circleId = uuidv4();
    const circleRecordId = `${boardId}/circle/${circleId}`;

    // for firefox - not work drag
    event.dataTransfer.setData('text', event.target.id);
    event.dataTransfer.setData('circleId', circleRecordId);
    // for firefox end

    const canvas = document.createElement('canvas');
    canvas.id = 'drag-image';
    document.body.append(canvas);
    const canv = document.getElementById('drag-image');

    const context = canvas.getContext('2d');

    context.fillStyle = color;
    context.strokeStyle = color;
    context.textBaseline = 'hanging';
    context.beginPath();
    context.arc(50, 95, 50, 0, 2 * Math.PI);
    context.stroke();
    if (role === 'circle') {
      context.fill();
    }
    context.fillText(title, 20, 26);

    event.dataTransfer.setDragImage(canv, 40, 85);

    const timestamp = new Date().getTime();
    createCircle(circleRecordId, {
      title: title,
      id: circleId,
      parentId: 'root',
      role: role,
      color,
      timestamp,
      circleBg: ''
    });
  };

  const handleDragOver = event => {
    event.preventDefault();
  };

  const handleDrop = event => {
    event.preventDefault();
    const circleId = event.dataTransfer.getData('circleId');

    deleteCircle(circleId);
    document.getElementById('drag-image').remove();
  };

  return (
    <div className="AddCircle text-left" onDragOver={handleDragOver} onDrop={handleDrop}>
      <div className="typeSection-wrapper">
        <div className="typeBtn-wrapper">
          <button
            className={`text-center type-btn ${role === 'circle' ? 'selected' : ''}`}
            aria-label="circle"
            onClick={() => setRole('circle')}
          >
            <div className="d-inline-block type circleType"></div>
            <span>circle</span>
          </button>
          <button
            className={`text-center type-btn ${role === 'group' ? 'selected' : ''}`}
            aria-label="group"
            onClick={() => setRole('group')}
          >
            <div className="d-inline-block type hoopType"></div>
            <span>group</span>
          </button>
        </div>
      </div>

      <div className="example-wrapper d-flex text-center">
        <div
          className="example d-flex flex-column justify-content-center"
          style={{
            backgroundColor: role === 'circle' ? color : 'transparent',
            border: `3px solid ${color}`
          }}
          draggable="true"
          onDragStart={handleDragStart}
        >
          <input
            name="nameInput"
            className="input w-100 mb-0 text-center"
            type="text"
            value={title}
            aria-label={`${role} title`}
            placeholder={`type ${role} name`}
            autoFocus={false}
            onChange={event => setTitle(event.target.value)}
            onKeyDown={event => {
              event.nativeEvent.key === 'Enter' && handleSubmit(event);
            }}
          />
        </div>
      </div>

      <div className="colorSection-wrapper">
        <ColorPicker className="AddCirclePicker" onChange={setColor} color={color} />
      </div>
      <div className="text-center btn-cta-wrapper">
        <button
          className="btn btn-primary px-5"
          type="submit"
          aria-label="Add"
          onClick={handleSubmit}
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default AddCircle;
